import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class DocumentSpecificSearchService {
  inPdp: boolean = false;
  constructor(private http: HttpClient, private occService: OccEndpointsService) { }

  getCustomDocumentDetails(searchDetails, pageSize, query, currentPage, sort?) {
    return this.http.get(this.occService.buildUrl(`mydocuments/kbdocument?pageSize=${pageSize}&page=${currentPage}&searchText=${query}&docType=${searchDetails?.docType}&docCategory=${searchDetails?.productCategory}&docLanguage=${searchDetails?.language}&sort=${sort}`));
  }
  getDocSearchPage() {
    return this.http.get(this.occService.buildUrl(`mydocuments/form`));
  }
  getDownloadPopup() {
    return this.http.get(this.occService.buildUrl(`mydocuments/getuserdetail`));
  }
  getDoubleOpt(docCode, value) {
    return this.http.get(this.occService.buildUrl(`mydocuments/document-update-request/doubleopt?documentId=${docCode}&documentValue=${value}`));
  }
  postListingPage(data) {
    return this.http.post(this.occService.buildUrl(`mydocuments/submit`), data);
  }
  postSubscribe(data) {
    return this.http.post(this.occService.buildUrl(`mydocuments/document-subscribe?documentCode=${data.code}&email=${data.email}&name=${data.name}&revision=${data.revision}&documentLanguage=${data.language}`), null);
  }
  myFavDocListPage(currentPage, pageSize, sort?) {
    return this.http.get(this.occService.buildUrl(`mydocuments/getfavoritelist?currentPage=${currentPage}&pageSize=${pageSize}&sort=${sort}`));
  }
  removeDocandUnsubscribe(data) {
    console.warn(data);

    return this.http.post(this.occService.buildUrl(`mydocuments/removedocumentfavoritepage?documentCode=${data.favoriteListEntryDocument.code}&documentLanguage=${data.favoriteDocumentLanguageISO}&catalogId=${data.favoriteListEntryCatalog}`), null);
  }
  removeFavFromPdp(data: any) {
    return this.http.post(this.occService.buildUrl(`mydocuments/removedocumentpdppage?documentCode=${data.code}&documentLanguage=${data.language}`), null);
  }
  removeFavDoc(data: any) {
    return this.http.post(this.occService.buildUrl(`mydocuments/removedocumentotherpage?documentCode=${data.code}&documentLanguage=${data.isoCode}`), null);
  }
  addToFavFromPdp(data: any) {
    return this.http.post(this.occService.buildUrl(`mydocuments/adddocumenttofavoritelistpdppage?documentCode=${data.code}&documentLanguage=${data.language}&email=${data.email}&name=${data.name}&revision=${data.revision}`), null);
  }
  exceptPdpAddToFavFrom(data: any) {
    return this.http.post(this.occService.buildUrl(`mydocuments/adddocumenttofavoritelistotherpage?documentCode=${data.code}&documentLanguage=${data.language}&email=${data.email}&name=${data.name}&revision=${data.revision}`), null);
  }

  getTimeStampInPdf(data): Observable<Blob> {
    const options = {
      responseType: 'blob' as 'json',
    };
    return this.http
      .get<Blob>(this.occService.buildUrl(`pdfDocument/document-download?url=${data.url}&documentCode=${data.documentCode}&documentLanguage=${data.documentLanguage}&revision=${data.revision}`), options);
  }
}
